const numberFormatters = new Map();

export function formatCurrency(
  amount: number,
  currency: string | undefined,
  trimDecimals: boolean = false
): string | number {
  if (!currency || currency === '' || !amount) {
    return amount ?? 0;
  }

  let numberFormat = numberFormatters.get(currency);

  if (!numberFormat) {
    const minimumFractionDigits = trimDecimals && amount % 1 === 0 ? 0 : 2;

    numberFormat = new Intl.NumberFormat('en', {
      style: 'currency',
      currency,
      minimumFractionDigits,
    });
    numberFormatters.set(`${currency}/${minimumFractionDigits}`, numberFormat);
  }

  return numberFormat.format(amount);
}

export const getEmptyTotal = () => ({
  amount: 0,
  currency: undefined,
});
